module.exports = __webpack_public_path__ + "img/nav_5_active.b2cab81f.gif";